// extracted by mini-css-extract-plugin
module.exports = {"root":"_2ywFv","visible":"_3S08Q","content":"_2KLFv","text":"_2eYBg","buttons":"_2a1Dq","button":"_1OA4Q","link":"ilEvv","emphasis":"_2hYt4"};